import * as style from '@/avatars/index';
import { createAvatar } from '@dicebear/core';
import { Avatar, AvatarProps } from './ui/avatar';
export const GoonAvatar = ({ seed, ...imageProps }: { seed: string | undefined } & AvatarProps) => {
  const avatar = createAvatar(style, {
    seed: seed?.toLowerCase(),
  });
  return <Avatar src={avatar.toDataUri()} {...imageProps} />;
};
